var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserId({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_1674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 15.8889C14.6871 15.8889 16.0548 14.5211 16.0548 12.8339C16.0548 11.1466 14.6871 9.77887 12.9998 9.77887C11.3126 9.77887 9.94482 11.1466 9.94482 12.8339C9.94482 14.5211 11.3126 15.8889 12.9998 15.8889Z",
    fill: "#5C5CAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1668 2.8889C15.1668 2.50581 15.0146 2.13841 14.7438 1.86753C14.4729 1.59664 14.1055 1.44446 13.7224 1.44446H12.2779C11.8949 1.44446 11.5275 1.59664 11.2566 1.86753C10.9857 2.13841 10.8335 2.50581 10.8335 2.8889V7.22224H15.1668V2.8889Z",
    fill: "#5C5CAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40997 19.5C7.28719 19.6481 7.22069 19.8348 7.22219 20.0272V21.6667H18.7777V20.0055C18.7799 19.8131 18.7133 19.6261 18.59 19.4783C17.8891 18.6975 17.025 18.0805 16.0589 17.6711C15.0928 17.2617 14.0485 17.0699 13 17.1094C11.9498 17.0726 10.9044 17.2678 9.93823 17.681C8.97205 18.0942 8.10881 18.7152 7.40997 19.5Z",
    fill: "#5C5CAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2224 4.33334H16.6113V5.77779H20.2224V23.1111H5.77794V5.77779H9.38905V4.33334H5.77794C5.39485 4.33334 5.02745 4.48553 4.75656 4.75641C4.48568 5.0273 4.3335 5.3947 4.3335 5.77779V23.1111C4.3335 23.4942 4.48568 23.8616 4.75656 24.1325C5.02745 24.4034 5.39485 24.5556 5.77794 24.5556H20.2224C20.6055 24.5556 20.9729 24.4034 21.2438 24.1325C21.5146 23.8616 21.6668 23.4942 21.6668 23.1111V5.77779C21.6668 5.3947 21.5146 5.0273 21.2438 4.75641C20.9729 4.48553 20.6055 4.33334 20.2224 4.33334Z",
    fill: "#5C5CAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_1674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserId);
export default __webpack_public_path__ + "static/media/user-id.8cdaef332d219b2a232cedca51c21a83.svg";
export { ForwardRef as ReactComponent };